/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    isAdminLoggedIn: false,
    isTrainerLoggedIn: false,
    paginationCertified: {
      sortBy: 'username',
      descending: false,
      rowsPerPage: 10,
      page: 1
    },
    paginationUncertified: {
      sortBy: 'testDate',
      descending: true,
      rowsPerPage: 10,
      page: 1},
    totalLogsCertified: 0,
    totalLogsUncertified: 0,
    searchVal: '',
    selectedTab: 0
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      if (token) {
        state.isUserLoggedIn = true
      } else {
        state.isUserLoggedIn = false
        state.isAdminLoggedIn = false
      }
    },
    setUser (state, user) {
      state.user = user
    },
    setAdmin (state, param) {
      state.isAdminLoggedIn = param
      //console.log("----setAdmin state.isAdminLoggedIn = " + state.isAdminLoggedIn)
    },
    setTrainer (state, param) {
      state.isTrainerLoggedIn = param
    },
    setAnswers (state, answers) {
      state.user.completedQuiz = true
      state.user.answers = answers
    },
    setPaginationCertified (state, pagination) {
      state.paginationCertified = pagination
    },
    setPaginationUncertified (state, pagination) {
      state.paginationUncertified = pagination
    },
    setTotalLogsCertified (state, totalLogsCertified) {
      state.totalLogsCertified = totalLogsCertified
    },
    setTotalLogsUncertified (state, totalLogsUncertified) {
      state.totalLogsUncertified = totalLogsUncertified
    },
    setSearchVal (state, searchVal) {
      state.searchVal = searchVal
    },
    setSelectedTab (state, selectedTab) {
      state.selectedTab = selectedTab
    }
  },
  actions: {
    logout ({commit}) {
      commit('setToken', null)
      commit('setUser', null)
      commit('setAdmin', false)
      commit('setTrainer', false)
      commit('setPaginationCertified', {
        sortBy: 'username',
        descending: false,
        rowsPerPage: 10,
        page: 1
      })
      commit('setPaginationUncertified', {
        sortBy: 'testDate',
        descending: true,
        rowsPerPage: 10,
        page: 1})
      commit('setTotalLogsCertified', 0)
      commit('setTotalLogsUncertified', 0)
      commit('setSearchVal', '')
      commit('setSelectedTab', 0)
    },
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setUser ({commit}, user) {
      commit('setUser', user)
    },
    setAdmin ({commit}, param) {
      commit('setAdmin', param)
    },
    setTrainer ({commit}, param) {
      commit('setTrainer', param)
    },
    setAnswers ({commit}, answers) {
      commit('setAnswers', answers)
    },
    setPaginationCertified ({commit}, pagination) {
      commit('setPaginationCertified', pagination)
    },
    setPaginationUncertified ({commit}, pagination) {
      commit('setPaginationUncertified', pagination)
    },
    setTotalLogsCertified ({commit}, totalLogsCertified) {
      commit('setTotalLogsCertified', totalLogsCertified)
    },
    setTotalLogsUncertified ({commit}, totalLogsUncertified) {
      commit('setTotalLogsUncertified', totalLogsUncertified)
    },
    setSearchVal ({commit}, searchVal) {
      commit('setSearchVal', searchVal)
    },
    setSelectedTab ({commit}, selectedTab) {
      commit('setSelectedTab', selectedTab)
    }
  }
})
